<template>
  <v-dialog :value="isOpen" width="500" @input="$emit('closed')">
    <v-card>
      <v-card-title class="subheading font-weight-bold px-4 pb-0">
        <v-spacer></v-spacer>
        <v-icon @click="$emit('closed')">close</v-icon>
      </v-card-title>

      <v-card-text class="pt-0 px-4 text-xs-center">
        <v-icon large color="accent">help_outline</v-icon>
        <h3 class="accent--text">Need Help?</h3>
        <p class="mt-3">
          Having issues using this platform or want to give us feedback? Send an email to
          <a href="mailto:support@huirepo.com"> <b>support@huirep.com</b> </a>
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
	name: 'ContactModal',
	props: ['isOpen']
}
</script>
